var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { Gewinnermittlungsart } from '../../office-location-datev-settings/types/datev-enums.js';
/**
 * Result of a completed Gewinnermittlungsart switch (PRD #1319 / RS-004).
 *
 * `carryOverCount` is the number of `MODE_SWITCH_CARRY_OVER` voucher rows the
 * switch seeded — objects DATEV already knows about under the outgoing
 * trigger, now suppressed on the incoming one. `foldForwardCount` is the
 * number of objects that will newly export on the next run in the incoming
 * mode (the Übergangs-Bestand / new revenue). Both counts are surfaced back
 * to the user for confirmation transparency; the richer *preview-before-
 * confirm* flow lands in RS-005.
 */
export class DatevModeSwitchResponseDto {
    officeLocationId;
    gewinnermittlungsart;
    carryOverCount;
    foldForwardCount;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], DatevModeSwitchResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DatevModeSwitchResponseDto.prototype, "gewinnermittlungsart", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DatevModeSwitchResponseDto.prototype, "carryOverCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DatevModeSwitchResponseDto.prototype, "foldForwardCount", void 0);
//# sourceMappingURL=datev-mode-switch.response.dto.js.map